import LoginPageFooter from './loginPageFooter';
import SignInWithGoogle from './signInWithGoogle';
import WebsiteLogo from '@/components/ui/WebsiteLogo';

const LoginLeftSection = () => {
  return (
    <div
      className='col-span-2 border-r-4'
      style={{
        borderRight: '4px solid',
        borderImageSlice: 1,
        borderImageSource:
          'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 0.12) 43.63%, rgba(102, 102, 102, 0) 100%)',
        backdropFilter: 'blur(66px)',
        background: 'rgba(255,255,255,0.04)',
      }}
    >
      <div className='grid h-screen place-content-center px-5'>
        <WebsiteLogo
          width={200}
          height={53}
          className='mx-auto'
        />
        <h1 className='mb-5 pt-8 text-center text-xl leading-[48px] font-bold text-white lg:text-[32px]'>
          Sign in to your account
        </h1>
        <div className='mb-16 flex w-full flex-col justify-center gap-y-7'>
          <SignInWithGoogle />
        </div>
        <LoginPageFooter />
      </div>
    </div>
  );
};

export default LoginLeftSection;
